const feedbackRouteOrigin = "https://softmax.com";
export const feedbackQueryParam = "feedback";

function toFeedbackUrl(input: string | URL): URL {
  return input instanceof URL
    ? new URL(input.toString())
    : new URL(input, feedbackRouteOrigin);
}

function sortQueryEntries(
  [keyA, valueA]: [string, string],
  [keyB, valueB]: [string, string],
) {
  if (keyA === keyB) {
    return valueA.localeCompare(valueB);
  }

  return keyA.localeCompare(keyB);
}

function normalizeFeedbackSearchParams(searchParams: URLSearchParams): string {
  const normalized = new URLSearchParams();
  const entries = Array.from(searchParams.entries()).filter(
    ([key]) => key !== feedbackQueryParam,
  );

  for (const [key, value] of entries.toSorted(sortQueryEntries)) {
    normalized.append(key, value);
  }

  return normalized.toString();
}

export function buildFeedbackPageRoute(input: string | URL): string {
  const url = toFeedbackUrl(input);
  const search = normalizeFeedbackSearchParams(url.searchParams);
  return `${url.pathname}${search ? `?${search}` : ""}`;
}

export function buildFeedbackHref({
  route,
  sessionId,
}: {
  readonly route: string;
  readonly sessionId: string;
}): string {
  const url = toFeedbackUrl(route);
  url.search = normalizeFeedbackSearchParams(url.searchParams);
  url.searchParams.set(feedbackQueryParam, sessionId);
  return `${url.pathname}${url.search}`;
}
